import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';

import {AppRoute} from '../models/AppRoute';
import {shouldDetachInactiveScreens} from '../navigation/util';
import CartScreen from '../screens/cart/CartScreen';

import GiftCardStoreOrderConfirmationScreen from './screens/GiftCardStoreOrderConfirmationScreen';
import {GiftCardShopStackParamList} from './types/navigationTypes';
import {
  GiftCardStoreCheckoutScreen,
  GiftCardStoreReviewScreen,
  GiftCardStoreShopScreen,
} from './screens';

const GiftCardShopStack = createStackNavigator<GiftCardShopStackParamList>();

export const GiftCardShopStackNavigator = () => {
  return (
    <GiftCardShopStack.Navigator
      initialRouteName={AppRoute.GIFT_CARDS_HOME}
      // DIS-1420: gift-card orders land here via pollOrderStatus → GIFT_CARDS_MAIN; no native
      // Screen detach (rn-screens Fabric reparent crash). Web unchanged. See navigation/util.
      detachInactiveScreens={shouldDetachInactiveScreens()}
      screenOptions={{
        headerShown: false,
      }}>
      <GiftCardShopStack.Screen
        name={AppRoute.GIFT_CARDS_HOME}
        component={GiftCardStoreShopScreen}
      />
      <GiftCardShopStack.Screen
        name={AppRoute.GIFT_CARDS_STORE_REVIEW}
        component={GiftCardStoreReviewScreen}
      />
      <GiftCardShopStack.Screen
        name={AppRoute.GIFT_CARDS_STORE_CHECKOUT}
        component={GiftCardStoreCheckoutScreen}
      />
      <GiftCardShopStack.Screen
        name={AppRoute.GIFT_CARDS_STORE_SECRET_CART}
        // @ts-expect-error - Type mismatch needs investigation
        component={CartScreen}
      />
      <GiftCardShopStack.Screen
        name={AppRoute.GIFT_CARDS_STORE_ORDER_CONFIRMATION}
        component={GiftCardStoreOrderConfirmationScreen}
      />
    </GiftCardShopStack.Navigator>
  );
};
